import React from 'react';
import { useField } from 'formik';
import FieldError from '@sls-react/components/Form/FieldError';

interface Props {
  className?: string;
  name: string;
}

const FormikFieldError: React.FC<Props> = ({ className, name }) => {
  const [field, meta] = useField(name);

  return (
    <FieldError className={className} name={name}>
      {meta.error}
    </FieldError>
  );
};

export default FormikFieldError;
